<template>
  <!-- Teleported to <body> so the fixed-position modal isn't trapped by an ancestor's
       overflow/transform (the event cards it is opened from sit inside expanders). Same
       bootstrap modal markup as SuccessModal, plus a backdrop and Escape/backdrop-click to close. -->
  <Teleport to="body">
    <div v-if="show" class="modal d-block" role="dialog" aria-modal="true" @click.self="$emit('close')">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">{{ title }}</h4>
          </div>
          <div class="modal-body"><slot>{{ message }}</slot></div>
          <div class="modal-footer">
            <a role="button" class="btn cancel-btn" @click="$emit('close')">{{ cancelLabel }}</a>
            <a role="button" class="btn procricket-btn text-white" :class="{ 'confirm-danger': danger }" @click="$emit('confirm')">{{ confirmLabel }}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </Teleport>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "Are you sure?" },
    message: { type: String, default: "" },
    confirmLabel: { type: String, default: "Confirm" },
    cancelLabel: { type: String, default: "Cancel" },
    // Red confirm button, for destructive actions.
    danger: { type: Boolean, default: false }
  },
  emits: ["confirm", "close"],
  watch: {
    show(now) {
      if (now) document.addEventListener("keydown", this.onKey);
      else document.removeEventListener("keydown", this.onKey);
    }
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    onKey(e) {
      if (e.key === "Escape") this.$emit("close");
    }
  }
}
</script>

<style scoped>
.confirm-danger,
.confirm-danger:hover {
  background-color: #c0392b;
  border-color: #c0392b;
}
</style>
